import { useContext } from 'react';

import WidgetConfigurationContext from 'data-lake/preview/contexts/WidgetConfigurationContext';

const useWidgetConfiguration = () => {
  const context = useContext(WidgetConfigurationContext);

  if (!context) {
    throw new Error('useWidgetConfiguration hook needs to be used inside WidgetConfigurationContext');
  }

  return context;
};

export default useWidgetConfiguration;
